import React from "react"
import { Stack } from "@chakra-ui/react"

import { LearnPage, LearnPageAttributesMinimal, LearnPageImage, LearnPageTitle } from "@components/LearnPage"
import { LearnPageItemProps } from "./LearnPageResults"

const LearnPageItemMobile = ({ page }: LearnPageItemProps) => (
  <LearnPage item={page}>
    <LearnPageImage mb={2} />
    <Stack textAlign="left">
      <LearnPageTitle />
      <LearnPageAttributesMinimal />
    </Stack>
  </LearnPage>
)

export default React.memo(LearnPageItemMobile)
